import { Layout } from "../UI/layouts/Layout";

/** Header, sidebar and footer around the server-rendered public pages. */
export default function SiteLayout() {
  return <Layout />;
}
